export const DATA = {
  "Skill level": "Beginner",
  "Time to complete": "Approx. 60 hours",
  Certificate: "Included",
  Prerequesties: "None",
  description: "Essential Computer Skills for Career & Productivity",
  about:
    "Master essential computer applications including document editing, spreadsheets, presentations, internet navigation, and graphic design. This course enhances digital skills, productivity, and communication for students and professionals in today's tech-driven world.",
  skills: ["Document Editing", "Data Management", "Digital Communication"],
  reviews: {
    1: {
      name: "Harper McNulty",
      review:
        "This Computer Applications course was extremely helpful! I learned how different software tools work and how to apply them in real-life tasks. Very clear and practical.",
    },
    2: {
      name: "Ebrahim Malik",
      review:
        "A very well-organized course. It taught me essential computer skills like working with documents, spreadsheets, and presentations with ease.",
    },
    3: {
      name: "Sofia Gutiérrez",
      review:
        "I loved how beginner-friendly the lessons were. Understanding everyday computer tools became so much easier thanks to this course.",
    },
    4: {
      name: "Ryder Hamilton",
      review:
        "A great introduction to computer fundamentals. The instructor explained each application clearly and gave useful examples.",
    },
    5: {
      name: "Aaliyah Mendez",
      review:
        "This course boosted my confidence in using productivity tools. Learning keyboard shortcuts and formatting tricks was especially helpful.",
    },
    6: {
      name: "Nikita Morozov",
      review:
        "Perfect course for beginners! It covers everything from file management to using office applications. Very practical learning.",
    },
    7: {
      name: "Phoebe Sutton",
      review:
        "The lessons were simple yet powerful. I now understand how to create documents, manage data, and build presentations efficiently.",
    },
    8: {
      name: "Jasper Connors",
      review:
        "Very useful and easy to follow. This course helped me improve my computer literacy and feel more comfortable using digital tools.",
    },
    9: {
      name: "Anastasia Blume",
      review:
        "The course explained the basics of computer applications in a clear and structured manner. Great for anyone wanting to improve workplace skills.",
    },
    10: {
      name: "Caleb Thornton",
      review:
        "I learned so much about everyday software tools. The practical exercises made the concepts stick naturally.",
    },
    11: {
      name: "Mirai Tan",
      review:
        "A very well-paced course! I especially enjoyed the modules on spreadsheets and presentations. Very beginner-friendly.",
    },
    12: {
      name: "Johan Eriksson",
      review:
        "The course covered all essential applications used in work environments. I feel much more confident using computers now.",
    },
    13: {
      name: "Lina Khoury",
      review:
        "The instructor was great at explaining how different tools operate. I really benefited from the hands-on tasks.",
    },
    14: {
      name: "Trevor Simons",
      review:
        "Excellent course for anyone starting with computers. The modules were well-structured and easy to understand.",
    },
    15: {
      name: "Hailey Vaughan",
      review:
        "Very clear explanations with practical examples. I now know how to manage files, edit documents, and create simple presentations.",
    },
    16: {
      name: "Keon Park",
      review:
        "I enjoyed the straightforward approach of this course. It helped me understand the fundamentals of common computer applications.",
    },
    17: {
      name: "Marisol Peña",
      review:
        "Great course! I loved learning how to use spreadsheets effectively. The examples were very clear and helpful.",
    },
    18: {
      name: "Declan Murphy",
      review:
        "The lessons were simple but extremely useful. I can confidently use office tools for daily tasks now.",
    },
    19: {
      name: "Ameera Rahman",
      review:
        "This course provided a solid foundation in digital skills. I especially appreciated the real-world examples.",
    },
    20: {
      name: "Finley Brock",
      review:
        "A very practical course for beginners. The step-by-step explanations helped me learn without feeling overwhelmed.",
    },
    21: {
      name: "Talía Ríos",
      review:
        "I loved the hands-on activities! They made learning computer applications much more engaging and effective.",
    },
    22: {
      name: "Hassan Idris",
      review:
        "This course helped me understand essential office tools and basic computer operations. Great for students and professionals alike.",
    },
    23: {
      name: "Autumn Keller",
      review:
        "The course made using computer applications feel simple and approachable. The examples were relatable and easy to follow.",
    },
    24: {
      name: "Leonard Osei",
      review:
        "The instructor explained every concept patiently and clearly. I now feel comfortable working with digital documents and spreadsheets.",
    },
    25: {
      name: "Veronica Miles",
      review:
        "Very insightful course! It covered all the important applications and gave me the confidence to use them effectively in my daily tasks.",
    },
  },
  modules: {
    "Introduction to Computers & Digital Devices.": [],
    "Operating systems Basics (Windows)": [],
    "file & Folder Management": [],
    "Document Creation & Formatting (Word/Docs)": [],
    "Spreadsheet Operations (Excel/Sheets)": [],
    "Charts & Data Visualization in Spreadsheets": [],
    "Professional Presentation Creation (PowerPoint/Slides)": [],
    "Basic Graphic Design with Canva/Photoshop": [],
    "Installing & Managing Software": [],
    "Typing Skills & Speed Improvement": [],
    "PDF Management & Document Conversion": [],
    "IT Trends & Career Awareness": [],
  },
};
